import apiAtividade from '../../atividades/service/atividade.service';
import * as types from "./cnae.actionTypes";
import formActions from "@common/store/form/form.actions";
import { takeEvery, call, put, select } from "redux-saga/effects";
import cnaeActions from "./cnae.actions";
import atividadeActions from "../../atividades/store/atividade.actions";
import decaSolicitacaoSelector from "../../../store/deca.selectors";
import cnaeSelector from "../store/cnae.selectors";

export default workSaga;

function* workSaga() {
  yield takeEvery(types.MAIN_SAGA_CNAE, mainSagaCnae);
  yield takeEvery(types.SET_SAGA_CNAE, setSagaCnae);
  yield takeEvery(types.DELETE_SAGA_CNAE, deleteSagaCnae);
  yield takeEvery(types.ADD_SAGA_CNAE, addSagaCnae);
  yield takeEvery(types.ADICIONA_AUTOMATICAMENTE_ATIVIDADE, AdicionaAutomaticamenteAtividadePorCnae);
}

function* AdicionaAutomaticamenteAtividadePorCnae() {

  let cnaeState = yield select(cnaeSelector.cnae);

  let { cnaes } = cnaeState;

  if(cnaes.length == 0) return;

  var ids = cnaes.map(x=>x.IdCnae);

  const result = yield call(apiAtividade.BuscaAtividadesPorIdsCnae, ids);
  
  yield put(atividadeActions.addListaAtividade(result.data));

}

function* addSagaCnae(action) {
  const { payload } = action;

  yield put(cnaeActions.addCnae(payload));
  yield put(formActions.gridReload());
  yield put(cnaeActions.loadIdsCnae());
}

function* setSagaCnae(action) {
  const { payload } = action;
  yield put(cnaeActions.setCnae(payload));
  yield put(formActions.gridReload());
  yield put(cnaeActions.loadIdsCnae());
}

function* mainSagaCnae(action) {
  const { payload } = action;
  yield put(cnaeActions.mainCnae(payload));
  yield put(formActions.gridReload());
}

function* deleteSagaCnae(action) {
  const { payload } = action;

  let decaSolicitacaoState = yield select(decaSolicitacaoSelector.deca);
  let cnaeState = yield select(cnaeSelector.cnae);

  const UtilizarVinculoCNAEAtividadenaSolicitacao = decaSolicitacaoState.registrarSolicitacao.parametro.find(
    (x) => x.Descricao == "UtilizarVinculoCNAEAtividadenaSolicitacao"
  );

  let { cnaes } = cnaeState;
  let cnaesArray = [...cnaes];

  cnaesArray = cnaesArray.filter((x) => x.IdCnae != payload.IdCnae);

  if (payload.Principal && cnaesArray.length > 0) {
    cnaesArray[0] = { ...cnaesArray[0], Principal: 1 };
  }

  if (UtilizarVinculoCNAEAtividadenaSolicitacao.Valor == "S") {
    yield put(atividadeActions.sagaAtividadeRemoveByCnae(payload));
  }

  yield put(cnaeActions.deleteCnae(cnaesArray));
  yield put(formActions.gridReload());
  yield put(cnaeActions.loadIdsCnae());
}
